import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { canonicalUrl } from '@/lib/site';

function upsert(selector: string, create: () => HTMLElement, attr: string, value: string) {
  let el = document.head.querySelector<HTMLElement>(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export default function CanonicalUrl() {
  const { pathname } = useLocation();

  useEffect(() => {
    const url = canonicalUrl(pathname);
    upsert('link[rel="canonical"]', () => Object.assign(document.createElement('link'), { rel: 'canonical' }), 'href', url);
    upsert('meta[property="og:url"]', () => {
      const m = document.createElement('meta');
      m.setAttribute('property', 'og:url');
      return m;
    }, 'content', url);
  }, [pathname]);

  return null;
}
